import React, { useState, useEffect } from "react";
import { IoLocationSharp } from "react-icons/io5";
import { FaBed, FaBath } from "react-icons/fa";
import { SlSizeFullscreen } from "react-icons/sl";
import { FaSchool } from "react-icons/fa6";
import axios from "axios";
import { formatNumberComma, formatNumber } from "../utils/numberUtils";

const HouseGrid = ({ data = [], type = "" }) => {
  const defaultCarImage = `/wp-content/uploads/2024/09/house-placeholder.jpg`;
  const [images, setImages] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchStreetViewImage = async (address, id) => {
      try {
        const url = `https://maps.googleapis.com/maps/api/streetview`;
        const response = await axios.get(url, {
          params: {
            size: "600x300",
            location: address,
            key: process.env.REACT_APP_GOOGLE_API,
          },
          responseType: "blob",
        });

        const imageBlob = URL.createObjectURL(response.data);
        setImages((prevImages) => ({ ...prevImages, [id]: imageBlob }));
      } catch (error) {
        console.error("Error fetching the Street View image:", error);
        setErrors((prevErrors) => ({
          ...prevErrors,
          [id]: "Failed to fetch the Street View image.",
        }));
        setImages((prevImages) => ({ ...prevImages, [id]: defaultCarImage }));
      }
    };

    data.forEach((car) => {
      if (!car?.featured_image_url && car?.address?.address) {
        fetchStreetViewImage(car.address.address, car.id);
      }
    });
  }, [data]);

  return (
    <div className="house-grid">
      {data.length > 0
        ? data.map((car, index) => {
            const imageSrc =
              car?.featured_image_url || images[car.id] || defaultCarImage;

            return (
              <div key={index} className="house-card">
                <a
                    href={`/details/?detail_id=${car.id}${
                      car.id.length > 5 && type !== "" ? `&type=${type}` : ""
                    }`}
                  >
                  <div>
                    <img
                      src={imageSrc}
                      alt="House"
                      className="car-image"
                      onError={(e) => {
                        e.target.src = defaultCarImage;
                      }}
                    />
                  </div>
                </a>
                <div className="content">
                <h3>
  <a
    href={`/details/?detail_id=${car.id}${
      car.id.length > 5 && type !== "" ? `&type=${type}` : ""
    }`}
    dangerouslySetInnerHTML={{ __html: car?.title?.rendered || car?.address?.address }}
  ></a>
</h3>

                  {(car?.meta?.hp_location) && (
                    <div className="car-attr">
                      <span>
                        <IoLocationSharp size={18} />
                        {car?.meta?.hp_location}
                      </span>
                    </div>
                  )}
                  {(car?.meta?.hp_h_fs_beds ||
                    car?.meta?.hp_h_fs_baths ||
                    car?.meta?.hp_size_sq_ft ||
                    car?.meta?.hp_school_district ||
                    car?.bedrooms ||
                    car?.bathrooms ||
                    car?.squareFeet) && (
                    <div className="car-attr-wrap">
                      {car?.meta?.hp_h_fs_beds && (
                        <div className="car-attr">
                          <span>
                            <FaBed size={18} />
                            {car?.meta?.hp_h_fs_beds} beds
                          </span>
                        </div>
                      )}
                      {car?.bedrooms && (
                        <div className="car-attr">
                          <span>
                            <FaBed size={18} />
                            {car?.bedrooms} beds
                          </span>
                        </div>
                      )}
                      {car?.meta?.hp_h_fs_baths && (
                        <div className="car-attr">
                          <span>
                            <FaBath size={16} />
                            {car?.meta?.hp_h_fs_baths} baths
                          </span>
                        </div>
                      )}
                      {car?.bathrooms && (
                        <div className="car-attr">
                          <span>
                            <FaBath size={16} />
                            {car?.bathrooms} baths
                          </span>
                        </div>
                      )}
                      {car && car.meta?.hp_size_sq_ft > 0 && (
                        <div className="car-attr">
                          <span>
                            <SlSizeFullscreen size={12} />
                            {formatNumberComma(car.meta.hp_size_sq_ft)} sq.ft
                          </span>
                        </div>
                      )}
                      {car && car.squareFeet > 0 && (
                        <div className="car-attr">
                          <span>
                            <SlSizeFullscreen size={12} />
                            {formatNumberComma(car.squareFeet)} sq.ft
                          </span>
                        </div>
                      )}
                      {car?.meta?.hp_school_district && (
                        <div className="car-attr">
                          <span>
                            <FaSchool size={18} />
                            {car?.meta?.hp_school_district}
                          </span>
                        </div>
                      )}
                    </div>
                  )}

                  {car?.meta?.hp_price ? (
                    <span className="car-attr price-tag">
                      ${formatNumber(car?.meta?.hp_price)}
                    </span>
                  ) : car?.mlsListingPrice ? (
                    <span className="car-attr price-tag">
                      ${formatNumber(Number(car?.mlsListingPrice || 0))}
                    </span>
                  ) : (
                    <span className="car-attr price-tag">
                      Contact seller for the price
                    </span>
                  )}
                </div>
              </div>
            );
          })
        : null}
      {Object.values(errors).length > 0 && <p>Some images failed to load.</p>}
    </div>
  );
};

export default HouseGrid;
